import React, { Component } from "react";
import { message, notification, Alert, Typography, Progress, Result, List } from "antd";
import { connect } from "react-redux";
import axios from "axios";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {
  ModalItem,
  ButtonItem,
  InputNumberItem,
  DatePickerItem,
  SegmentedItem,
} from "../../../../Components/Items";
import { FilePdfOutlined } from "@ant-design/icons";
import construirDocumentoLote from "../../../../Pdf/listaEmpaquetadoLotePdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Text } = Typography;

const OPCIONES_TIPO_INSUMO = [
  { label: "Todos", value: "todos" },
  { label: "Solo obligatorios", value: "obligatorio" },
  { label: "Solo no obligatorios", value: "no_obligatorio" },
];

class ModalGenerarPickingLote extends Component {
  state = {
    fechaDesde: null,
    fechaHasta: null,
    folioDesde: null,
    folioHasta: null,
    tipoInsumo: "todos",
    cargando: false,
    generando: false,
    progreso: { actual: 0, total: 0 },
    resultado: null,
  };

  componentDidUpdate(prevProps) {
    // Si hay una generación en curso (o ya terminó y aún no se ve el
    // resultado), NO resetear al reabrir: el cierre solo oculta el modal, la
    // generación sigue corriendo en segundo plano y perderíamos su progreso o
    // su resultado si limpiamos el estado aquí.
    if (
      this.props.visible &&
      !prevProps.visible &&
      !this.state.cargando &&
      !this.state.generando &&
      !this.state.resultado
    ) {
      this.setState({
        fechaDesde: null,
        fechaHasta: null,
        folioDesde: null,
        folioHasta: null,
        tipoInsumo: "todos",
        cargando: false,
        generando: false,
        progreso: { actual: 0, total: 0 },
        resultado: null,
      });
    }
  }

  reiniciarFormulario = () => {
    this.setState({
      fechaDesde: null,
      fechaHasta: null,
      folioDesde: null,
      folioHasta: null,
      tipoInsumo: "todos",
      cargando: false,
      generando: false,
      progreso: { actual: 0, total: 0 },
      resultado: null,
    });
  };

  cerrarModal = () => {
    // Limpia el resultado al cerrar para que la próxima vez que se abra (o si
    // ya está abierto) arranque en el formulario, no en la pantalla de
    // resultado de la consulta anterior.
    this.reiniciarFormulario();
    this.props.onCancel();
  };

  puedeGenerar = () => {
    if ((this.props.ventaIds || []).length > 0) return true;
    const { fechaDesde, fechaHasta, folioDesde, folioHasta } = this.state;
    const hayFolio = folioDesde != null || folioHasta != null;
    const hayFecha = !!(fechaDesde || fechaHasta);
    return hayFolio || hayFecha;
  };

  construirNombreArchivo = (totalSecciones) => {
    if ((this.props.ventaIds || []).length > 0) {
      return `Picking_Seleccion_${totalSecciones}pedidos.pdf`;
    }
    const { fechaDesde, fechaHasta, folioDesde, folioHasta } = this.state;
    const partes = [];
    if (folioDesde != null || folioHasta != null) {
      partes.push(`Folio_${folioDesde ?? ""}-${folioHasta ?? ""}`);
    }
    if (fechaDesde || fechaHasta) {
      const fmt = (m) => (m ? m.format("YYYYMMDD") : "");
      partes.push(`Fecha_${fmt(fechaDesde)}-${fmt(fechaHasta)}`);
    }
    return `Picking_Lote_${partes.join("_")}_${totalSecciones}pedidos.pdf`;
  };

  generarPdfLote = async () => {
    const { empresaId, headersToken, ventaIds, origenKey } = this.props;
    const { fechaDesde, fechaHasta, folioDesde, folioHasta, tipoInsumo } = this.state;
    const haySeleccion = (ventaIds || []).length > 0;

    if (!this.puedeGenerar()) {
      message.warning("Indica un rango de folio o de fecha.");
      return;
    }

    this.setState({ cargando: true, resultado: null });

    try {
      const res = await axios.post(
        "ventasEcommerce/datosPdfEmpaquetadoLote",
        haySeleccion
          ? { empresaId, ventaIds, origenKey }
          : {
              empresaId,
              folioDesde,
              folioHasta,
              fechaDesde: fechaDesde ? fechaDesde.clone().startOf("day").toISOString() : undefined,
              fechaHasta: fechaHasta ? fechaHasta.clone().endOf("day").toISOString() : undefined,
              tipoInsumo,
            },
        { headers: headersToken },
      );

      if (res.data.success !== 2) {
        message.warning(res.data.message || "No se pudieron obtener los pedidos.");
        return;
      }

      const { empresa, secciones, omitidos, excluidosPorFiltro, sinInsumosEmpaquetables, ventaIdsExcluidos } = res.data;

      if (!secciones || secciones.length === 0) {
        if (
          (excluidosPorFiltro || []).length > 0 ||
          (sinInsumosEmpaquetables || []).length > 0 ||
          (ventaIdsExcluidos || []).length > 0
        ) {
          // No se generó PDF, pero hay pedidos que sí matchearon el rango:
          // mostramos el detalle de por qué ninguno quedó incluido.
          this.setState({
            resultado: {
              totalSecciones: 0,
              omitidos: omitidos || [],
              excluidosPorFiltro: excluidosPorFiltro || [],
              sinInsumosEmpaquetables: sinInsumosEmpaquetables || [],
              ventaIdsExcluidos: ventaIdsExcluidos || [],
            },
          });
        } else {
          message.info("No se encontraron pedidos con picking pendiente para ese filtro.");
        }
        return;
      }

      this.setState({
        cargando: false,
        generando: true,
        progreso: { actual: 0, total: secciones.length },
      });

      const dd = await construirDocumentoLote({
        empresa,
        secciones,
        onProgress: (actual, total) => this.setState({ progreso: { actual, total } }),
      });

      pdfMake.createPdf(dd).download(this.construirNombreArchivo(secciones.length));

      this.setState({
        resultado: {
          totalSecciones: secciones.length,
          omitidos: omitidos || [],
          excluidosPorFiltro: excluidosPorFiltro || [],
          sinInsumosEmpaquetables: sinInsumosEmpaquetables || [],
          ventaIdsExcluidos: ventaIdsExcluidos || [],
        },
      });

      notification.success({
        message: "Picking en lote listo",
        description: `Se generó el PDF con ${secciones.length} pedido(s). Si cerraste la ventana, revisa tus descargas.`,
        placement: "bottomRight",
        duration: 8,
      });
    } catch (err) {
      message.error("No se pudo generar el PDF del lote.");
      notification.error({
        message: "No se pudo generar el picking en lote",
        description: "Ocurrió un error al generar el PDF del lote. Vuelve a intentarlo.",
        placement: "bottomRight",
      });
    } finally {
      this.setState({ cargando: false, generando: false });
    }
  };

  render() {
    const { visible, ventaIds } = this.props;
    const haySeleccion = (ventaIds || []).length > 0;
    const {
      fechaDesde,
      fechaHasta,
      folioDesde,
      folioHasta,
      tipoInsumo,
      cargando,
      generando,
      progreso,
      resultado,
    } = this.state;

    return (
      <ModalItem
        title={
          <span>
            <FilePdfOutlined /> Generar picking en lote
          </span>
        }
        visible={visible}
        onCancel={this.cerrarModal}
        width={560}
        spinning={cargando}
      >
        {resultado ? (
          <Result
            status={
              resultado.totalSecciones === 0
                ? "warning"
                : resultado.omitidos.length === 0
                  ? "success"
                  : "warning"
            }
            title={
              resultado.totalSecciones === 0
                ? "Ningún pedido quedó incluido en el PDF"
                : `PDF generado con ${resultado.totalSecciones} pedido(s)`
            }
            subTitle={
              resultado.omitidos.length > 0
                ? `${resultado.omitidos.length} pedido(s) no se pudieron incluir.`
                : undefined
            }
            extra={[
              <ButtonItem key="nueva" onClick={this.reiniciarFormulario}>
                Nueva consulta
              </ButtonItem>,
              <ButtonItem key="cerrar" type="primary" onClick={this.cerrarModal}>
                Cerrar
              </ButtonItem>,
            ]}
          >
            {resultado.sinInsumosEmpaquetables.length > 0 && (
              <>
                <Alert
                  type="warning"
                  showIcon
                  style={{ marginBottom: 12 }}
                  message={`${resultado.sinInsumosEmpaquetables.length} pedido(s) no tienen insumos empaquetables en este origen (esto NO depende del filtro elegido: son servicio/flete, libro virtual, o dropshipping que surte el proveedor directo).`}
                />
                <List
                  size="small"
                  header={<Text strong>Detalle: sin insumos empaquetables</Text>}
                  dataSource={resultado.sinInsumosEmpaquetables}
                  style={{ marginBottom: 12, textAlign: "left" }}
                  renderItem={(p) => (
                    <List.Item>
                      <div style={{ width: "100%" }}>
                        <Text strong>{p.serieNumero || "—"}</Text>
                        <ul style={{ margin: "4px 0 0 20px", padding: 0 }}>
                          {(p.insumos || []).map((ins, idx) => (
                            <li key={idx}>
                              <Text type="secondary" style={{ fontSize: 12 }}>
                                {ins.clave} — {ins.descripcion}: {ins.motivo}
                              </Text>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </List.Item>
                  )}
                />
              </>
            )}
            {resultado.excluidosPorFiltro.length > 0 && (
              <>
                <Alert
                  type="info"
                  showIcon
                  style={{ marginBottom: 12 }}
                  message={`${resultado.excluidosPorFiltro.length} pedido(s) se excluyeron por el filtro de obligatorio/no-obligatorio elegido (ninguno de sus insumos empaquetables cumplía).`}
                />
                <List
                  size="small"
                  header={<Text strong>Detalle: excluidos por el filtro elegido</Text>}
                  dataSource={resultado.excluidosPorFiltro}
                  style={{ marginBottom: 12, textAlign: "left" }}
                  renderItem={(p) => (
                    <List.Item>
                      <div style={{ width: "100%" }}>
                        <Text strong>{p.serieNumero || "—"}</Text>
                        <ul style={{ margin: "4px 0 0 20px", padding: 0 }}>
                          {(p.insumos || []).map((ins, idx) => (
                            <li key={idx}>
                              <Text type="secondary" style={{ fontSize: 12 }}>
                                {ins.clave} — {ins.descripcion} (
                                {ins.obligatorio === true
                                  ? "obligatorio"
                                  : ins.obligatorio === false
                                    ? "no obligatorio"
                                    : "no aplica"}
                                )
                              </Text>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </List.Item>
                  )}
                />
              </>
            )}
            {resultado.omitidos.length > 0 && (
              <List
                size="small"
                header={<Text strong>Pedidos omitidos</Text>}
                dataSource={resultado.omitidos}
                renderItem={(o) => (
                  <List.Item>
                    <Text>{o.serieNumero || "—"}</Text>: {o.motivo}
                  </List.Item>
                )}
              />
            )}
            {(resultado.ventaIdsExcluidos || []).length > 0 && (
              <>
                <Alert
                  type="warning"
                  showIcon
                  style={{ marginTop: 12, marginBottom: 12 }}
                  message={`${resultado.ventaIdsExcluidos.length} de los pedidos seleccionados no se incluyeron.`}
                />
                <List
                  size="small"
                  header={<Text strong>Seleccionados excluidos</Text>}
                  dataSource={resultado.ventaIdsExcluidos}
                  style={{ textAlign: "left" }}
                  renderItem={(e) => (
                    <List.Item>
                      <Text strong>{e.serieNumero || e.ventaId}</Text>: {e.motivo}
                    </List.Item>
                  )}
                />
              </>
            )}
          </Result>
        ) : (
          <>
            {haySeleccion ? (
              <Alert
                type="info"
                showIcon
                style={{ marginBottom: 16 }}
                message={`Se imprimirán ${ventaIds.length} pedido(s) seleccionado(s).`}
                description="Se incluyen los que estén en 'Pedido pagado' o 'Empaquetado'; si alguno seleccionado no aplica, se te avisará cuáles y por qué."
              />
            ) : (
              <Alert
                type="info"
                showIcon
                style={{ marginBottom: 16 }}
                message="Combina el picking de varios pedidos pagados en un solo PDF."
                description="Incluye pedidos en 'Pedido pagado' y en 'Empaquetado' que aún tengan insumos pendientes de marcar. Indica un rango de folio y/o de fecha."
              />
            )}

            {!haySeleccion && (
              <>
            <div style={{ marginBottom: 12, display: "flex", gap: 12 }}>
              <div style={{ flex: 1 }}>
                <Text strong>Fecha desde</Text>
                <DatePickerItem
                  style={{ width: "100%", marginTop: 4 }}
                  value={fechaDesde}
                  onChange={(m) => this.setState({ fechaDesde: m })}
                  allowClear
                  disabled={generando}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Text strong>Fecha hasta</Text>
                <DatePickerItem
                  style={{ width: "100%", marginTop: 4 }}
                  value={fechaHasta}
                  onChange={(m) => this.setState({ fechaHasta: m })}
                  allowClear
                  disabled={generando}
                />
              </div>
            </div>

            <div style={{ marginBottom: 12, display: "flex", gap: 12 }}>
              <div style={{ flex: 1 }}>
                <Text strong>Folio desde</Text>
                <InputNumberItem
                  style={{ width: "100%", marginTop: 4 }}
                  min={0}
                  value={folioDesde}
                  onChange={(val) => this.setState({ folioDesde: val })}
                  disabled={generando}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Text strong>Folio hasta</Text>
                <InputNumberItem
                  style={{ width: "100%", marginTop: 4 }}
                  min={0}
                  value={folioHasta}
                  onChange={(val) => this.setState({ folioHasta: val })}
                  disabled={generando}
                />
              </div>
            </div>

            <div style={{ marginBottom: 16 }}>
              <Text strong>Insumos a incluir</Text>
              <div style={{ marginTop: 4 }}>
                <SegmentedItem
                  options={OPCIONES_TIPO_INSUMO}
                  value={tipoInsumo}
                  onChange={(value) => this.setState({ tipoInsumo: value })}
                />
              </div>
            </div>
              </>
            )}

            {generando && (
              <>
                <Progress
                  percent={
                    progreso.total ? Math.round((progreso.actual / progreso.total) * 100) : 0
                  }
                  style={{ marginBottom: 8 }}
                />
                <Alert
                  type="info"
                  showIcon
                  style={{ marginBottom: 16 }}
                  message="Puedes cerrar esta ventana. La generación sigue en segundo plano y el PDF se descargará solo; te avisaremos con una notificación cuando esté listo."
                />
              </>
            )}

            <div style={{ textAlign: "right" }}>
              <ButtonItem
                type="primary"
                verde
                loading={cargando || generando}
                disabled={!this.puedeGenerar()}
                onClick={this.generarPdfLote}
              >
                Generar PDF combinado
              </ButtonItem>
            </div>
          </>
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalGenerarPickingLote);
